import React from "react";
import { Bar } from "react-chartjs-2";
import "./Chart.css";

export function BarChart(props) {
  const bolunen = props.bolunecekSayi === undefined ? 3 : props.bolunecekSayi;

  let labelCol = props.label.length / bolunen;
  let labelLimit = [];

  for (let i = 0; i < labelCol; i++) {
    labelLimit.push({ count: i === 0 ? 0 : i * bolunen });
  }

  const getData = () => {
    return {
      labels: props.label,
      datasets: [
        {
          data: props.data,
          backgroundColor:
            props.color === undefined
              ? ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"]
              : props.color,
          hoverBackgroundColor: ["#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107"],
          borderWidth: 0,
        },
      ],
    };
  };

  return (
    <div className="row" style={{ maxWidth: "100%", margin: "0px" }}>
      <div className="col-12" style={{ maxWidth: "100%" }}>
        {props.data.length === 0 ? (
          <div>
            <b>Gösterilecek Veri Bulunamadı...</b>
          </div>
        ) : (
          <Bar
            data={getData}
            width={400}
            height={550}
            options={{
              maintainAspectRatio: false,
              title: {
                display: true,
                fontSize: 17,
              },
              scales: {
                x: {
                  ticks: {
                    autoSkip: false,
                    maxRotation: 75, // Labellerin çapraz olarak dönmemesi için
                    minRotation: 75, // Labellerin çapraz olarak dönmemesi için
                  },
                },
                y: {
                  beginAtZero: true,
                },
              },
              plugins: {
                legend: {
                  display: false, //props.legendVisible === undefined ? true : false,
                  position: "bottom",
                  align: "start",
                  rtl: true,

                  labels: {
                    fontSize: "12px",
                  },
                },
                tooltip: {
                  callbacks: {
                    label: function (tooltipItem) {
                      let total = 0;
                      tooltipItem.dataset.data.map((d) => {
                        total = total + parseInt(d);
                        return total;
                      });
                      const count = props.count && props.count[tooltipItem.dataIndex]; // "count" değerini güvenli bir şekilde alıyoruz
                      const toplambina = props.toplambina && props.toplambina[tooltipItem.dataIndex]; // "count" değerini güvenli bir şekilde alıyoruz
                      const currentValue = tooltipItem.dataset.data[tooltipItem.dataIndex];
                      const oran = props.oran;
                      const percentage = oran == true ? parseFloat(((count / toplambina) * 100).toFixed(1)) : parseFloat(((currentValue / total) * 100).toFixed(1));

                      let tooltipLabel = props.noFixed
                        ? tooltipItem.label + ": " + currentValue + (props.cins !== undefined ? props.cins : " ")
                        : tooltipItem.label +
                          ": " +
                          parseFloat(currentValue)
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                      tooltipLabel += " (" + percentage + "%)";

                      if (count !== undefined) {
                        tooltipLabel += " Denetlenen Bina Sayısı: " + count + "\n Toplam Bina Sayısı: " + toplambina;
                      }

                      return tooltipLabel;
                    },
                  },
                },
              },
            }}
          />
        )}
      </div>
    </div>
  );
}
